enum Priority {
  pass = 4,
  low = 3,
  med = 2,
  high = 1,
}

export default Priority;
